export default function (Vue) {
    Vue.prototype.can = function(capability, team_capability) {
        const capabilities = typeof team_capability !== 'undefined' ? this.$store.getters['entities/teams/capabilities'] : this.$store.getters['entities/projects/capabilities']
        if(typeof capabilities == 'undefined' || !Array.isArray(capabilities)) {
            return false
        }

        return capabilities.includes(capability)
    }
}